module.exports = __webpack_public_path__ + "static/media/support20_small_banner.dd9a5cbd.jpg";